import React from 'react';

import classNames from 'classnames';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
	error?: string;
}

export default function ErrorMessage({ error, className, ...props }: Props) {
	if (!error) return null;

	return (
		<div className={classNames('field-error-message text-red-600 animate-fade-in', className)} {...props}>
			<span className="text-xs font-sans font-medium">{error}</span>
		</div>
	);
}
